import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { useRefProvider } from 'src/common/stores/contexts/ref-provider';

import { UitkCard, UitkCardContentSection } from 'uitk-react-cards';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkSpacing } from 'uitk-react-spacing';

import { InquiryProminence } from 'src/common/__generated__/api';
import { SharedUiContactHostWrapper } from '../shared-ui/offers/contact-host-wrapper';
import { SharedUiPropertySingleOfferWrapper } from '../shared-ui/offers/single-offer-price-wrapper';

export const SingleOfferPriceWrapper: React.FunctionComponent<Record<string, unknown>> = () => {
  const [singleOfferPrice] = useRefProvider('singleOfferPrice');

  const priceBlock = () => (
    <>
      <UitkSpacing margin={{ large: { block: 'three', inlinestart: 'three' } }}>
        <UitkCard overflow={true}>
          <UitkSpacing padding={{ blockstart: 'three', blockend: 'six', large: { inline: 'three' } }}>
            <UitkCardContentSection padded={false}>
              <SharedUiPropertySingleOfferWrapper />
            </UitkCardContentSection>
          </UitkSpacing>
        </UitkCard>
      </UitkSpacing>
      <UitkSpacing margin={{ block: 'six', inlinestart: 'unset' }}>
        <UitkLayoutFlex justifyContent="center">
          <SharedUiContactHostWrapper prominence={InquiryProminence.LOW} />
        </UitkLayoutFlex>
      </UitkSpacing>
    </>
  );

  return (
    <Viewport>
      <ViewLarge>
        <UitkLayoutPosition type="sticky" position={{ top: 'twelve', zindex: 'layer1' }} cloneElement>
          <div ref={singleOfferPrice}>{priceBlock()}</div>
        </UitkLayoutPosition>
      </ViewLarge>
      <ViewSmall>
        <div ref={singleOfferPrice}>{priceBlock()}</div>
      </ViewSmall>
    </Viewport>
  );
};
